import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

export const getSeoDescription = (description?: string, fallback?: string) => {
  if (typeof fallback !== 'undefined' && fallback != '') {
    return description
      ? description
      : documentToPlainTextString(JSON.parse(fallback)).slice(0, 400);
  }
  if (typeof description !== 'undefined') {
    return description;
  }
  return '';
};
